module.exports = __webpack_public_path__ + "assets/icon-heart-love.893a6651.svg";